<template>
   <pos-documents :configurl="createFromBundleLink" />
</template>
<script>
import PosDocuments from "../pos-document/receipt/Receipt.vue";
export default {
   props: ['bundleId'],
   components: {
      PosDocuments
   },
   computed: {
      createFromBundleLink() {
         return "/api/sales/createfromBundle/" + this.bundleId
      }
   }
};
</script>
